// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BottomNavBar {
  bottom: 0;
  background-color: rgb(150, 146, 146);
  width: 100%;
  z-index: 99;
}`, "",{"version":3,"sources":["webpack://./src/css/bottom_nav_bar.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,WAAW;AACb","sourcesContent":[".BottomNavBar {\n  bottom: 0;\n  background-color: rgb(150, 146, 146);\n  width: 100%;\n  z-index: 99;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
